<template>
  <RevAccordionItem disable-chevron-animation @click="onClick">
    <template #prefix>
      <IconCheckInCircle class="text-static-success-hi" size="24" />
    </template>
    <template #title>
      {{ i18n(translations.title) }}
    </template>
    <template #body>
      <section
        class="bg-static-info-mid text-static-default-hi rounded-lg flex flex-col items-start gap-20 p-16"
      >
        <h3 class="heading-3">
          {{ i18n(translations.freeReturns) }}
        </h3>
        <RevTextList>
          <RevTextListItem v-for="(icon, key) in items" :key :icon>
            {{ i18n(translations[key]) }}
          </RevTextListItem>
        </RevTextList>
      </section>
    </template>
  </RevAccordionItem>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'
import { IconCalendarWithCheck } from '@ds/icons/IconCalendarWithCheck'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconMail } from '@ds/icons/IconMail'
import { IconRefund } from '@ds/icons/IconRefund'

import translations from './AttractiveReturnsAccordion.translations'

const i18n = useI18n()

const items = {
  setupReturn: IconMail,
  shipDevice: IconCalendarWithCheck,
  cashBack: IconRefund,
}
const { trackClick } = useTracking()
const onClick = () => {
  trackClick({
    zone: 'return_policy',
    name: '30_days_free_trial',
  })
}
</script>
